/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import { activity } from '@/api/ajax';
import { moneyInt } from '@/tools/money';
const remove = async ({
  vm,
  row: { sersviceActivityId: serviceActivityId, userId }
}) => {
  await vm.$confirm('是否确认删除？');
  await activity.delPerson({ serviceActivityId, userId });
  vm.saveSuccess();
};
export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  fullName: {
    label: '姓名',
    prop: 'fullName'
  },
  phone: {
    label: '手机号',
    prop: 'phone'
  },
  status: {
    label: '状态',
    prop: 'status',
    formatter({ status, superviseStatus }) {
      return superviseStatus == 3
        ? '已停用'
        : { 0: '', 1: '已启用', 2: '已停用', 3: '已注销' }[status] || '-';
    }
  },
  entryStatus: {
    label: '入驻状态',
    prop: 'entryStatus',
    formatter({ entryStatus }) {
      return ['未入驻', '已入驻', '已退出'][entryStatus];
    }
  },
  taskPrice: {
    label: '结算金额',
    prop: 'taskPrice',
    formatter({ taskPrice }) {
      return moneyInt(taskPrice) + '元';
    }
  },
  settlementStatus: {
    label: '结算状态',
    prop: 'settlementStatus',
    formatter({ settlementStatus }) {
      return ['未结算', '结算中', '已结算'][settlementStatus];
    }
  },
  handler: {
    label: '操作',
    render(h, ctx, row) {
      const vm = ctx.parent;
      return (
        <div>
          <el-button
            type="text"
            onClick={remove.bind(null, { vm, row })}
            disabled={!row.deletable}
          >
            删除
          </el-button>
        </div>
      );
    }
  }
};
